const moment = require( 'moment' );
const IF = require( "infrontjs" );

import template from './AccountingIndexTemplate.html';

import { InAppState } from "../base/InAppState";
import { RoutinePlan } from "../../model/RoutinePlan";

import './../../components/general/main-menu';
import './../../components/general/header-bar';

export class AccountingIndexState extends InAppState
{
    static ROUTE = '/accounting';
    static ID = 'accounting-index';

    async enter()
    {
        let activePlan = null;
        const resp = await this.app.api.get(  '/routine/active' );
        if ( 200 === resp.status )
        {
            const activeRoutineData = await resp.json();
            activePlan = new RoutinePlan( activeRoutineData )
        }

        let remainingTime = '28 Tage';
        if ( activePlan )
        {
            remainingTime = 'wenige Minuten';
            const duration = moment.duration( activePlan.momentEndUtc.diff( moment() ) );
            if ( duration.as( 'days' ) > 0 )
            {
                remainingTime = ~~duration.as( 'days' );
                if ( 1 == remainingTime )
                {
                    remainingTime += ' Tag';
                }
                else
                {
                    remainingTime += ' Tage';
                }
            }
            else if ( duration.as( 'hours' ) > 0  )
            {
                remainingTime = ~~duration.as( 'hours' )  + ' Stunden';
            }
        }

        this.app.container.innerHTML = this.app.view.getHtml(
            template,
            {
                activePlan : activePlan,
                remainingTime : remainingTime
            }
        );

        const button = this.app.container.querySelector('.js-button');
        const circle = this.app.container.querySelector('.js-circle');
        const text = this.app.container.querySelector('.js-text');

        const radius = circle.getAttribute('r');
        const diameter = Math.round(Math.PI * radius * 2);
        const getOffset = (val = 0) => Math.round((100 - val) / 100 * diameter);

        if ( activePlan )
        {
            setTimeout( () =>
            {
                //const val = 48 + Math.floor(Math.random() * 50);
                let val = 0;
                if ( activePlan.checks && activePlan.maxPoints > 0 )
                {
                    val = activePlan.checks.length / activePlan.maxPoints * 100;
                }
                val = Math.min( val, 100 );
                circle.style.strokeDashoffset = getOffset(val);
                text.textContent = `${val.toFixed(2)}%`;
            }, 500 );
        }
    }

    async exit()
    {
    }
};
